import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { EngagementDiscountTierManager } from "@airdao/bond-periphery/core/contracts/types";
import { BigNumberish, AddressLike } from "ethers";

export type TierWithLevel = {
  level: BigNumberish;
  discount: BigNumberish;
}

export async function SetTier(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager, tier: TierWithLevel) {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  return await manager.setTier(tier.level, { discount: tier.discount });
}

export async function ClearTiers(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager) {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  return await manager.clearTiers();
}

export async function SetTiers(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager, tiers: TierWithLevel[]) {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  const mappedAndSorted = tiers.sort((a, b) => Number((BigInt(a.level) - BigInt(b.level)).toString())).map(tier => ({ discount:  tier.discount }));
  return await manager.setTiers(mappedAndSorted);
}

export async function RemoveTier(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager, level: BigNumberish) {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  return await manager.removeTier(level);
}

export async function SetOracle(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager, oracle: AddressLike) {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  return await manager.setOracle(oracle);
}

export async function ChangeOwner(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager, newOwner: AddressLike) {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  return await manager.transferOwnership(newOwner);
}

export const AdminMethods = {
  SetTier,
  ClearTiers,
  SetTiers,
  RemoveTier,
  SetOracle,
  ChangeOwner,
};

export default AdminMethods;